// 客服选择话务队列
export const CHOOSE_HW_QUEUE = "hwQueue";
// 客服选择话机
export const CHOOSE_HW_PHONE = "hwPhone";
// 用户信息
export const USER_INFO = "userinfo";
// 用户信息
export const TOKEN = "authToken";
// 所有客服信息
export const WAITER_INFO = "waiter";
// 权限信息
export const PERMISSION = "permission";
// 权限数组
export const PERMISSION_ARR = "permissionArr";

export const MVB2000WEB_KEY = "mvb2000webkey";

export const ROUTE_PLAN_MAP = "ROUTE_PLAN_MAP";

export const MODE = {
  ADD: 1,
  EDIT: 2
};

// 题目类型常量
export const QUESTION_TYPE = {
  SINGLE_CHOICE: "SINGLE_CHOICE",
  MULTIPLE_CHOICE: "MULTIPLE_CHOICE"
};

// 题目类型映射（类型值 -> 显示文本）
export const QUESTION_TYPE_MAP = {
  [QUESTION_TYPE.SINGLE_CHOICE]: "单选题",
  [QUESTION_TYPE.MULTIPLE_CHOICE]: "多选题"
};

// 资料类型常量
export const MATERIAL_TYPE = {
  VIDEO: "VIDEO",
  PDF: "PDF",
  IMAGE: "IMAGE"
};

// 资料类型映射（类型值 -> 显示文本）
export const MATERIAL_TYPE_MAP = {
  [MATERIAL_TYPE.VIDEO]: "视频",
  [MATERIAL_TYPE.PDF]: "文档",
  [MATERIAL_TYPE.IMAGE]: "图文"
};
